import { AxiosRequestConfig } from "axios"
import { apis } from "service"

const BASE_URL = 'https://xxl6-bbr3-kxzs.m2.xano.io/api:'
const reshare_cred = BASE_URL + 'FiAQK2sE/share_cred_v3'

export const shareCredentials = async (data: { partner_id: number, reshare: boolean }) => {
    const payload: AxiosRequestConfig<{ partner_id: number, reshare: boolean }> = {
        params: {
            partner_id: data.partner_id,
            reshare: data.reshare
        }
    }

    return apis.post(reshare_cred, payload)
}